export default function loadDateAndTime(datum){
    let date = new Date(datum * 1000).toLocaleDateString("es-US")
    let hour = new Date(datum * 1000).toLocaleTimeString("es-US")
    return date + " " + hour;
};